import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-global-warning',
    templateUrl: './global-warning.component.html',
    styleUrls: ['./global-warning.component.scss'],
    animations: [
        trigger('serverAvailableInOutTrigger', [
            transition(':enter', [style({ height: 0, opacity: 0 }), animate(300, style({ height: '2rem', opacity: 1 }))]),
            transition(':leave', [animate(100, style({ height: 0, opacity: 0 }))]),
        ]),
    ],
    imports: [],
})
export class GlobalWarningComponent implements OnInit, OnDestroy {
    private readonly _ngUnsubscribe = new Subject<void>();

    public isServerAvailable: boolean = true;
    public backendVersion?: string;
    public readonly frontendVersion = environment.version;

    constructor() {}

    ngOnInit(): void {
        // Subscribe to server availability state - not available for now
    }

    ngOnDestroy(): void {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }
}
